<template>
  <div class="video-player">
    <Header />
    <CopyrightWarning />

    <div class="back-content" @click="voltar" title="Voltar">
      <i class="fa-solid fa-arrow-left"></i>
    </div>

    <iframe v-if="videoUrl" :src="'https://player.vimeo.com/video/' + videoUrl.vimeo_id" width="100%" height="800px"
      frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>

    <div v-else-if="loading" class="mensagem">
      Carregando vídeo...
    </div>

    <div v-else class="mensagem">
      Vídeo não encontrado.
    </div>

    <Watermark />
  </div>
</template>

<style scoped src="../styles/Video.css" />

<script src="https://player.vimeo.com/api/player.js"></script>

<script>
import Header from '@/components/Header.vue'
import request from '../router/request'
import { antiPiracyMixin } from '@/mixins/antiPiracyMixin'
import Watermark from '@/components/Watermark.vue'
import CopyrightWarning from '@/components/CopyrightWarning.vue'

export default {
  name: 'VideoPlayer',
  mixins: [antiPiracyMixin],
  components: { Header, Watermark, CopyrightWarning },

  data() {
    return {
      videoUrl: '',
      loading: true
    }
  },

  watch: {
    '$route.query.codigo_aula': {
      immediate: true,
      handler() {
        this.viewVideo();
      }
    }
  },

  methods: {
    voltar() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },

    viewVideo() {
      const codigoAula = this.$route.query.codigo_aula;
      console.log('codigo_aula:', codigoAula);

      if (!codigoAula) {
        this.videoUrl = '';
        this.loading = false;
        return;
      }

      this.loading = true;

      request.post('asas/listarVideo', {
        codigo_aula: codigoAula
      })
        .then(response => {
          this.videoUrl = response.data[0];
        })
        .catch(() => {
          this.videoUrl = '';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>
